@keyframes shimmer {
    0% {
        background-position: 150% 0;
    }
    100% {
        background-position: -50% 0;
    }
}

.ai-loading-text {
    height: 8px;
    width: 100%;
    border-radius: 4px;
    background: linear-gradient(
        90deg,
        var(--ai-purple-pink-lt) 0%,
        var(--ai-purple-pink-lt) 40%,
        var(--ai-purple-pink-xxlt) 48%,
        var(--ai-purple-pink-xxlt) 52%,
        var(--ai-purple-pink-lt) 60%,
        var(--ai-purple-pink-lt) 100%
    );
    background-size: 200% 100%;
    animation: shimmer 1s linear infinite;
}
